/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-02 14:09:48
 * @Description:
 */

import "./FTEffectLoading.scss";

import { FTCanvasStore, FTImageStore } from "src/store";
import React, { useEffect } from "react";
import { rangNumber, withUnit } from "src/utils";

import { CanvasLoadingLarger } from "src/assets";
import FTLang from "src/utils/FTLang";
import FTProgress from "../FTProgress/FTProgress";
import clsx from "clsx";
import urls from "src/constant/url";
import { useLanguage } from "src/hooks";

interface IProps {
  progress?: number;
}

interface IState {
  quotes: string;
}
export default function FTEffectLoading(props: IProps) {
  const [quotes, setQuotes] = React.useState<string>("");
  const timer = React.useRef<any>(null);
  const { t } = useLanguage();

  const changeQuotes = () => {
    let index = Math.ceil(Math.random() * 23);
    let quotes: string = "goart_quotes";
    if (index < 10) quotes = quotes + "0" + index;
    else quotes = quotes + index;
    setQuotes(quotes);
  };

  useEffect(() => {
    changeQuotes();
    timer.current = setInterval(() => {
      changeQuotes();
    }, 3000);
    return () => {
      clearInterval(timer.current);
    };
  }, []);

  const { progress = 4 } = props;
  const { isMobile } = FTCanvasStore;
  const { unlockData } = FTImageStore.currentEffect || {};
  const newProgress = rangNumber(2, 100, Math.floor(progress));
  return (
    <div
      className={clsx("effect_loading", isMobile && "effect_loading_mobile")}>
      {unlockData && unlockData.posterImage && (
        <div className='effect_loading_img'>
          <img src={urls.assetsUrl + unlockData.posterImage} alt='' />
        </div>
      )}
      <div
        className='effect_loading_person'
        dangerouslySetInnerHTML={{
          __html: t(quotes)
        }}></div>

      <div className='effect_loading_header'>
        <div className='effect_loading_header_desc'>
          <span>
            {t("goart_drawering", {
              name: t(FTImageStore.currentEffect?.langKey) + " "
            })}
          </span>
          <span>{withUnit(newProgress, "%")}</span>
        </div>

        {newProgress > 0 && <FTProgress progress={newProgress} />}
      </div>
    </div>
  );
}
